// 验证浏览器是否支持ES2019
import { check } from './browser-check';
check();

import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import permission from './utils/permission';

import i18n from './i18n';
import installer from './as-needed';
import { iconsInstaller } from '@/components/IconSelect/util';

import DictData from '@/components/DictData/index.vue';
import LzdDataTableSearch from '@/components/lzd/data-table/search/index.vue';
import LzdDataTableEdit from '@/components/lzd/data-table/edit/index.vue';
import LzdDataTableImport from '@/components/lzd/data-table/import/index.vue';
import LzdDataTableExport from '@/components/lzd/data-table/export/index.vue';

import LzdOffice from '@/components/lzd/office/index.vue';
import LzdEditor from '@/components/lzd/editor/index.vue';
import LzdDatePicker from '@/components/lzd/date-picker/index.vue';
import LzdKvSelect from '@/components/lzd/kv-select/index.vue';
import LzdModal from '@/components/lzd/modal/index.vue';
import LzdRender from '@/components/lzd/render/index.vue';

import LzdUtil from './utils/lzd-util';

import 'element-plus/theme-chalk/display.css';
import 'ele-admin-plus/es/style/nprogress.scss';
import './styles/themes/rounded.scss';
import './styles/themes/dark.scss';
import './styles/index.scss';
import './styles/lzd.scss';
import { ONLYOFFICE_JS_URL } from './config/setting';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(permission);
app.use(i18n);
app.use(installer);
app.use(iconsInstaller);
// 全局注册组件
app.component('DictData', DictData);
app.component('LzdDataTableSearch', LzdDataTableSearch);
app.component('LzdDataTableEdit', LzdDataTableEdit);
app.component('LzdDataTableImport', LzdDataTableImport);
app.component('LzdDataTableExport', LzdDataTableExport);
app.component('LzdOffice', LzdOffice);
app.component('LzdEditor', LzdEditor);
app.component('LzdDatePicker', LzdDatePicker);
app.component('LzdKvSelect', LzdKvSelect);
app.component('LzdModal', LzdModal);
app.component('LzdRender', LzdRender);

app.mount('#app');

import { useGlobalExceptionHandler } from './global-exception-handler';

// 页面缓存处理
setTimeout(() => {
  LzdUtil.queryClientTrackUi();
  LzdUtil.loadVueComponents();

  const script = document.createElement('script');
  script.async = true;
  script.src = ONLYOFFICE_JS_URL;
  script.id = 'LZD_ONLYOFFICE_JS_URL';
  document.body.appendChild(script);

  // 重写原始方法 实现监听
  const lsSetItem = localStorage.setItem;
  localStorage.setItem = function (key: string, value: string) {
    lsSetItem.call(localStorage, key, value);
    if (typeof key !== 'string' || typeof value !== 'string') {
      return;
    }
    LzdUtil.saveUiCacheSetting(key, value);
  };
  const lsRemoveItem = localStorage.removeItem;
  localStorage.removeItem = function (key: string) {
    lsRemoveItem.call(localStorage, key);
    if (typeof key !== 'string') {
      return;
    }
    // 重置数据表格列
    if (key.endsWith('TableCols')) {
      lsRemoveItem.call(localStorage, key + 'Width');
    }
    LzdUtil.saveUiCacheSetting(key, '');
  };

  // 全局赋值，方便获取
  globalThis.__loadLzdUiCacheSettingValue = LzdUtil.getUiCacheSettingValue;

  // 企业全局异常捕获收集
  useGlobalExceptionHandler();
}, 0);

const ali_captcha = document.createElement('script');
ali_captcha.src =
  'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js';
// ali_captcha.async = true;
document.head.appendChild(ali_captcha);
